import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import StatGridItem from './StatGridItem';

function StatGrid({ data }) {
  const { items } = data || {};
  return (
    <Grid
      templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
      gap={30}
      alignItems='stretch'
      px={{ base: 30, xl: 60 }}
    >
      {items.map((item) => (
        <GridItem key={item._key}>
          <StatGridItem item={item} />
        </GridItem>
      ))}
    </Grid>
  );
}

export default StatGrid;
